/** General design guidelines in JSON format. */
export const DESIGN_TOKEN = {
  colors: {
    /** Gold */
    swatch_1: 'rgb(142, 120, 72)',
    /** Dark grey */
    swatch_2: 'rgb(68, 68, 68)',
    /** White */
    swatch_3: 'rgb(255, 255, 255)',
    /** Blue */
    swatch_4: 'rgb(143, 193, 253)',
    /** Light grey */
    swatch_5: 'rgba(220, 220, 220)',
    /** Dark blue */
    swatch_6: 'rgb(91, 137, 194)'
  },
  fonts: {
    /** Time New Roman */
    font_1: {
      family: '"Times New Roman", Times, serif',
      weight: {
        normal: '400',
        bold: '800'
      },
      style: {
        normal: 'normal',
        oblique: 'oblique'
      }
    },
    /** Arial */
    font_2: {
      family: 'Arial, Helvetica, sans-serif',
      weight: {
        normal: '400',
        semibold: '600',
        bold: '800'
      },
      styles: {
        normal: 'normal',
        italic: 'italic'
      }
    }
  },
};